<template>
	<div class="msg-analysis-img">
		<img :src="message" alt="">
	</div>
</template>

<script>
	import AppConfig from '../../../config/AppConfig.js'
	export default{
		name: 'MsgAnalysisImage',
		components:{
			
		},
		props:{
			msg:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			}
		},
		data(){
			return {
				message: ''
			}
		},
		methods:{
			formatImage(){
				let message = this.msg.content
				if(message.indexOf('http') === -1){
					message = AppConfig.host + message
				}
				if(message.indexOf('?x-oss-process=style') === -1 && message.indexOf('aliyuncs') !== -1){
					message += '?x-oss-process=style/thumb_w200'
				}
				this.message = message
			}
		},
		
		created() {
			this.formatImage()
		}
	}
</script>

<style>
	.msg-analysis-img img{
		max-width: 200px;
		border: 1px solid #EEEEEE;
		border-radius: 4px;
		cursor: pointer;
		display: block;
	}
</style>
